import { InjectionToken } from '@angular/core';

import { LOG_LEVEL } from './logger/log-level';

export interface AuthEnvironment {
  production: boolean;
  msalConfig: {
    auth: {
      clientId: string;
      redirectUri: string;
    };
  };
  apiConfig: {
    scopes: string[];
    uri: string;
  };
  b2cPolicies: {
    names: {
      signUpSignIn: string;
    };
    authorities: {
      signUpSignIn: {
        authority: string;
      };
    };
    authorityDomain: string;
  };
}

export interface BuildInfo {
  environment: string;
  version: string;
}

export interface EnvConfig {
  production: boolean;
  apiUrl: string;
  logLevel: LOG_LEVEL;
  buildInfo: BuildInfo;
  authEnv: AuthEnvironment;
  /** When true (Sandbox only), skips the compatible-version-exceeds-manifest validation
   *  so Update Managers can freely declare downgrade packages for test scenarios. */
  allowCompatibilityDowngrade: boolean;
  isSandbox: boolean;
}

export const ENV_CONFIG = new InjectionToken<EnvConfig>('ENV_CONFIG');
